<template>
  <div class="std-pagination" v-if="total > 0">
    <Pagination
      v-model="inner"
      :layout="layout"
      :sizes="sizes"
      align="right"
      small
      @change="emitChange"
    />
  </div>
</template>

<script>
/**
 * 统一分页组件。
 * 包裹 HeyUI Pagination，统一布局（总数 + 每页条数 + 页码 + 跳转）与右对齐样式。
 * 父组件以 :page.sync / :size.sync / :total 双向绑定，@change 触发重新查询。
 * 约定：HeyUI Pagination 的 v-model 对象形如 { page, size, total }，
 * 切换每页条数时其内部会自动把 page 重置为 1，并在 @change 触发前完成对 page/size 的就地更新。
 */
export default {
  name: 'StdPagination',
  props: {
    page: { type: Number, default: 1 },
    size: { type: Number, default: 10 },
    total: { type: Number, default: 0 },
    sizes: { type: Array, default: () => [10, 20, 50] },
    layout: { type: String, default: 'total,sizes,pager,jumper' }
  },
  data() {
    return { inner: { page: this.page, size: this.size, total: this.total } };
  },
  watch: {
    page(v) { this.inner.page = v; },
    size(v) { this.inner.size = v; },
    total(v) { this.inner.total = v; }
  },
  methods: {
    emitChange() {
      this.$emit('update:page', this.inner.page);
      this.$emit('update:size', this.inner.size);
      this.$emit('change', { page: this.inner.page, size: this.inner.size });
    }
  }
};
</script>

<style lang="less" scoped>
.std-pagination {
  margin-top: 12px;
  display: flex;
  justify-content: flex-end;
}
</style>
